/* eslint-disable react/destructuring-assignment */
import { useQuery } from '@apollo/client';
import { HeadProps } from 'gatsby';
import React, { Suspense } from 'react';
import { Loader } from '../../components/Loader';
import { SEO } from '../../components/Seo';
import { GET_PROPERTIES } from '../../graphql/properties';
import { defaultValuesResidential } from '../../hooks/useSearch';
import { SearchCategory } from '../../types/enums';
import { SearchResults } from '../../components/search-results-parts';

const LondonPages = (props) => {
  const { params } = props;

  // get the correct defaults
  //  console.log(params?.partProps);

  const variables = {
    ...defaultValuesResidential,
    page: 1,
    multiSearch: 'place=london',
  };

  if (params?.partProps?.includes('for-sale')) {
    variables.category = SearchCategory.Resale;
  }
  if (params?.partProps?.includes('to-rent')) {
    variables.category = SearchCategory.Rental;
  }
  if (params?.partProps?.includes('flats-')) {
    variables.propertyType = ['Flat'];
  }
  if (params?.partProps?.includes('houses-')) {
    variables.propertyType = ['House'];
  }
  if (params?.partProps?.includes('sold-properties') || params?.partProps?.includes('recently-let')) {
    variables.unavailable = true;
  }

  // check for page number
  const paramParts = params?.partProps?.split('/');

  if (paramParts && paramParts.length > 1 && paramParts[paramParts.length - 1]) {
    const last = +paramParts[paramParts.length - 1];
    // check it is a number
    if (!Number.isNaN(last)) {
      // variables.page = +params?.partProps.replace(/\D/g, '');
      variables.page = last;
    }
  }

  const {
    loading,
    error,
    data: propertiesData,
  } = useQuery(GET_PROPERTIES, {
    variables,
  });

  const data = {
    props: {
      properties: propertiesData?.properties,
      query: variables,
      pagePath: `/london/${paramParts?.length >= 1 ? paramParts[0] : ''}/`,
      pageNumber: variables.page,
    }, // Will be passed to the page component as "serverData" prop
  };

  // if(!data) return null;

  return (
    <Suspense fallback={<Loader />}>
      <SearchResults location={props?.location} serverData={data?.props} globalLoading={loading} />
    </Suspense>
  );
};
export default LondonPages;
export const Head = (props: HeadProps<Record<string, any>>) => {
  let title = 'Properties';

  if (props?.location?.pathname.includes('flats-')) {
    title = 'Flats';
  }
  if (props?.location?.pathname.includes('houses-')) {
    title = 'Houses';
  }
  if (props?.location?.pathname.includes('sold-properties')) {
    title += ' Sold';
  }
  if (props?.location?.pathname.includes('recently-let')) {
    title += ' Let';
  }

  if (props?.location?.pathname.includes('for-sale')) {
    title += ' For Sale';
  }
  if (props?.location?.pathname.includes('to-rent')) {
    title += ' For Rent';
  }

  title += ' in London';

  return <SEO title={title} />;
};
